// ======================================
// FILE: src/pages/DI/Inspection/FrmSupvOv.jsx
// ✅ React version of legacy frmSupvOv
// ✅ Displays pcs remaining + nonconformities
// ✅ NO password verification (per your request)
// ✅ Returns ClosedBy (employee id) to caller
// ======================================
import React, { useMemo, useState, useEffect, useCallback } from "react";

const FrmSupvOv = ({
  open,
  pcsRemaining,
  nonConformities,
  onCancel,
  onConfirm,
}) => {
  const [empId, setEmpId] = useState("");

  useEffect(() => {
    if (!open) {
      setEmpId("");
    }
  }, [open]);

  const valid = useMemo(() => {
    const n = Number(empId);
    return Number.isInteger(n) && n > 0;
  }, [empId]);

  const safePcsRemaining = useMemo(() => Number(pcsRemaining || 0), [pcsRemaining]);
  const safeNonConformities = useMemo(
    () => Number(nonConformities || 0),
    [nonConformities]
  );

  const handleEmpIdChange = useCallback((e) => {
    setEmpId(e.target.value);
  }, []);

  const handleConfirm = useCallback(() => {
    onConfirm?.(Number(empId));
  }, [onConfirm, empId]);

  if (!open) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.35)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
      }}
    >
      <div
        style={{
          background: "#fff",
          width: 520,
          borderRadius: 8,
          padding: 16,
        }}
      >
        <h3 style={{ marginTop: 0, marginBottom: 8 }}>Supervisor Override</h3>

        <div style={{ fontSize: 14, color: "#555", marginBottom: 14 }}>
          <div>
            <strong>Pieces Not Inspected:</strong> {safePcsRemaining}
          </div>
          <div>
            <strong>Non Conformities:</strong> {safeNonConformities}
          </div>
        </div>

        <div style={{ marginBottom: 14 }}>
          <label htmlFor="supv-empid" style={{ display: "block", marginBottom: 6 }}>
            Supervisor Employee ID (Closed By)
          </label>
          <input
            id="supv-empid"
            type="number"
            inputMode="numeric"
            value={empId}
            onChange={handleEmpIdChange}
            placeholder="Enter supervisor employee ID"
            style={{
              width: "100%",
              padding: 10,
              border: "1px solid #ccc",
              borderRadius: 6,
            }}
          />
          <div style={{ marginTop: 6, fontSize: 12, color: "#6c757d" }}>
            Password verification is disabled (per current requirements).
          </div>
        </div>

        <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
          <button
            onClick={onCancel}
            style={{
              padding: "8px 14px",
              background: "#eee",
              border: "1px solid #ddd",
              borderRadius: 4,
              color: "#333",
            }}
          >
            Cancel
          </button>

          <button
            onClick={handleConfirm}
            disabled={!valid}
            style={{
              padding: "8px 14px",
              background: "#0d6efd",
              border: "none",
              borderRadius: 4,
              color: "#fff",
              opacity: valid ? 1 : 0.6,
              cursor: valid ? "pointer" : "not-allowed",
            }}
          >
            Override & Close Job
          </button>
        </div>
      </div>
    </div>
  );
};

export default React.memo(FrmSupvOv);